import { Ifilter } from "../../Interfaces/filter";
import { fetchListVerificacion } from "../http-common";

const equipo = "Equipo";

const ComboEquipo = (request: Ifilter, controller = new AbortController()) => {
    return fetchListVerificacion.get(`${equipo}/Combo`, {
        params: request,
        signal: controller.signal,
    });
};

const EquipoService = {
    ComboEquipo
}

export { EquipoService };